import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Button,
  ModalBody,
  Form,
  FormGroup,
  Input,
  Label
} from "reactstrap"
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import useForm from "../../../lib/useForm"
import Loading from 'lib/loading'
import ListaControles from './form'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const formSwal = withReactContent(Swal)

const FormPerfil = ({ fechaModal, perfil_id}) => {

  const inicialForm = {
    perfil_id:    '',
    nome_perfil:  ''
  };

  const [form, onChange, setForm] = useForm(inicialForm)
  const [loading, setLoading]     = useState(true)

  const editPerfil = (perfil_id) => {
    try{
      const retorno = rest.get(rotas.perfil_cad+perfil_id)
      retorno.then(ret => {
        //console.log(ret)
        if ((ret.success) && (ret.lista != '')){
          setForm(ret.lista[0])
        }
      })
      setLoading(false)
      return (true)
    }catch(err){
      return (false)
    }
  }

  useEffect(() => {
    if (perfil_id != '') {
      editPerfil(perfil_id)
    } else {
      setForm(inicialForm)
      setLoading(false)
    }
  },[])

  //SUBMIT
  const handleSubmit = (evt) => {
    evt.preventDefault()


    if(form.Dashboard === 'S'){
      form.Vazia = 'N';
    }else{
      form.Vazia = 'S';
    }

    
    // console.log(form)

    formSwal.queue([{
      title:                'Deseja salvar ?',
      confirmButtonText:    'Salvar',
      showCancelButton:     true,
      text:                 'Essas informações serão salvas no banco',
      showLoaderOnConfirm:  true,
      cancelButtonColor:    '#d33',
      preConfirm: () => {
        const url = rotas.perfil_cad+'gravar.php'
        // console.log(perfil_id);
        if(form.perfil_id !== ''){
          return rest.post(url, form)
            .then(ret => {
              //console.log(ret)
              if (ret.success == 'S') {
                editPerfil(perfil_id)
                formSwal.fire('Salvo!', ret.msg, 'success')
              }else{
                formSwal.fire('Erro!',ret.msg,'error')
              }
            })
        }else{
          return rest.put(url, form)
            .then(ret => {
              //console.log(ret)
              if (ret.success == 'S') {
                perfil_id = ret.perfil_id;
                //console.log(perfil_id);
                let frm = form;
                frm.perfil_id = ret.perfil_id;

                setForm(frm);

                editPerfil(ret.perfil_id)
                formSwal.fire('Salvo!',ret.msg,'success')
              }else{
                formSwal.fire('Erro!',ret.msg,'error')
              }
            })
        }
      }
    }])
  }

  if (loading) {
    return (
      <ModalBody className ="loadingBody">
        <Loading tipo='componente'/>
      </ModalBody>
    )
  }else {
    return (
      <FormGroup className="formCadastro">
        <ModalBody className="pb-0">
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md='2'>
                <FormGroup>
                  <Label for="perfil_id">Perfil</Label>
                  <Input
                    disabled
                    style     = {{background: '#F9F9F9'}}
                    name      = "perfil_id"
                    id        = "perfil_id"
                    value     = {form.perfil_id}
                    onChange  = {onChange('perfil_id')}
                  />
                </FormGroup>
              </Col>
              <Col md ='10'>
                <FormGroup>
                  <Label for="perfil">Nome do Perfil</Label>
                  <Input
                    name      = "perfil"
                    id        = "perfil"
                    value     = {form.nome_perfil}
                    onChange  = {onChange('nome_perfil')}
                  />
                </FormGroup>
              </Col>
              <Col md ='12'>
                <Row>
                  <ListaControles
                    form      = {form}
                    onChange  = {onChange}
                  />
                </Row>
              </Col>
            </Row>
            <Col className="text-center p-3">
              <Button type="submit" className="mb-0 mt-0" color="success" size="md" >Salvar</Button>
              <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>Fechar</Button>
            </Col>
          </Form>
        </ModalBody>
      </FormGroup>
    )
  }
}

export default FormPerfil
